import { deleteApi, get, post } from "../GenericServices";

const CostCentre = {
  costCentre: (queryString) => {
    return get(`cost-centre${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getCostCentre: (id) => {
    return get(`cost-centre/${id}`);
  },
  saveCostCentre: (data) => {
    return post(`cost-centre`, data);
  },
  deleteCostCentre: (id) => {
    return deleteApi(`cost-centre/${id}`);
  },
  getCostCentreFilter: () => {
    return get(`cost-centre/user-session`);
  },
  getManagerDelegate: () => {
    return get("cost-centre/user-resp-cdc?allPages=true");
  },
  getServices: () => {
    return get("pfp_service?allPages=true");
  },
};

export default CostCentre;
